import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgRadioButtonComponent } from './pg-radio-button.component';
import { PgRadioGroupComponent } from './pg-radio-group.component';
import { PgRadioFactoryComponent } from './pg-radio-factory/pg-radio-factory.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [
    PgRadioGroupComponent,
    PgRadioButtonComponent,
    PgRadioFactoryComponent,
  ],
  exports: [
    PgRadioGroupComponent,
    PgRadioButtonComponent,
    PgRadioFactoryComponent,
  ],
})
export class PgRadioModule {}
